
import { namespace } from '@common/config/constants';
import { useTranslation } from 'react-i18next';

type Props = {
    id: string;
}


export default function ConditionNodeContainer({ id }: Props) {
    const { t } = useTranslation(namespace);

    return (
        <div style={{
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '18px',
            width: '100%',
        }}>{t('chatbot.conditionContentPlaceholder')}</div >
    )
}
